export const ExpressionStatus = Object.seal({
  include: 'include',
  exclude: 'exclude',
});

export const ConditionInclusion = Object.seal({
  all: 'all',
  any: 'any',
});

export const ExpressionType = Object.seal({
  ipAddresses: 'ipAddresses',
  device: 'device',
  deviceEncrypted: 'deviceEncrypted',
  locations: 'locations',
});
